"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const provider_test_id_1 = require("@framework/provider-test-id");
const SwitchInput = props => {
    const { name, label, disabled, readOnly, ...rest } = props;
    const { testId } = (0, provider_test_id_1.useTestId)();
    const testIdProps = testId ? { "data-testid": `${testId}-${name}` } : {};
    const suffix = name.split(".").pop();
    const form = (0, react_hook_form_1.useFormContext)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const localizedLabel = label === void 0 ? formatMessage({ id: `form.labels.${suffix}` }) : label;
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: form.control, render: ({ field }) => ((0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { sx: { my: 1 }, control: (0, jsx_runtime_1.jsx)(material_1.Switch, { name: field.name, checked: field.value, inputRef: field.ref, onChange: field.onChange, onBlur: field.onBlur, 
                // https://github.com/mui/material-ui/issues/37753 readOnly prop still evaluate `onChange` event
                disabled: disabled || readOnly, ...testIdProps, ...rest }), label: localizedLabel })) }));
};
exports.SwitchInput = SwitchInput;
//# sourceMappingURL=index.js.map